import { BN, User, ZERO } from '@velocity-exchange/sdk';

export function getTotalIsolatedDepositsForUser(user: User): BN {
	let total = ZERO;
	const perpPositions = user.getActivePerpPositions();
	for (const pos of perpPositions) {
		if (user.isPerpPositionIsolated(pos)) {
			total = total.add(
				user.getIsolatePerpPositionTokenAmount(pos.marketIndex)
			);
		}
	}
	return total;
}
